// extracted by mini-css-extract-plugin
export default {"clientMenuContainer":"ClientMenuIconStyles_clientMenuContainer__zFzOn","clientMenuIcon":"ClientMenuIconStyles_clientMenuIcon__SKAkI"};